<template>
    <div>
        <div class="main-header">
            <div class="container">
                <h2 class="main-header-text">Transaction Detail</h2>
            </div>
        </div>
        <div class="main-section mgt-40">
            <div class="container">
                <div class="main-card">
                    <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                    <div v-if="index == 0">

                        <form @submit.prevent="onSubmit" novalidate="">

                            <div class="form-card">
                                <div class="form-card-header">
                                    <h3>Transaction Detail</h3>
                                </div>
                                <div class="form-card-forms">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label> Transaction Ref Number</label>
                                        </div>
                                        <div class="col-md-8">
                                            {{TransactionDetail.TransactionRefNumber}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Reason Remark</label>
                                        </div>
                                        <div class="col-md-8">
                                            {{TransactionDetail.Remark}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Send Amount(MYR)</label>
                                        </div>
                                        <div class="col-md-8 text-bold">
                                            {{TransactionDetail.SendAmount}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Payout Amount({{TransactionDetail.PayoutCurrency}})</label>
                                        </div>
                                        <div class="col-md-8 text-bold">
                                            {{TransactionDetail.PayoutAmount}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>Exchange Rate</label>
                                        </div>
                                        <div class="col-md-8 text-bold">
                                            {{TransactionDetail.ExchangeRate}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-card">
                                <div class="form-card-header">
                                    <h3>Recipient Details</h3>
                                </div>
                                <div class="form-card-forms">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label for="">
                                                    First Name
                                                    <span class="required">*</span>
                                                </label>
                                                <input type="text" class="form-control text-uppercase" name="FirstName"
                                                    autocomplete="off" v-model="vModel.FirstName" data-vv-as='FirstName'
                                                    v-validate="'required'"
                                                    :class="{'input': true, 'is-danger': errors.has('FirstName') }" v-only-uppercase/>
                                                <div v-show="errors.has('FirstName')" class="help is-danger">
                                                    {{ errors.first('FirstName') }}</div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label for="">
                                                    Last Name                                                    
                                                </label>
                                                <input type="text" class="form-control text-uppercase" name="LastName"
                                                    autocomplete="off" v-model="vModel.LastName" data-vv-as='LastName'                                                    
                                                    :class="{'input': true }" v-only-uppercase/>                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- eo form card forms -->
                            </div>
                            <div class="submit-option">
                                <div class="left-option">
                                    <router-link :to="'/transaction'" class="btn submit-lefticon-btn">
                                        <span class="left-icon">
                                            <i class="material-icons">chevron_left</i>
                                        </span>
                                        <span class="btn-content">Cancel</span>
                                    </router-link>
                                </div>
                                <div class="right-option">
                                    <button class="btn submit-righticon-btn">
                                        <span class="btn-content">Amend</span>
                                        <span class="right-icon">
                                            <i class="material-icons">chevron_right</i>
                                        </span>
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div v-else-if="index == 1">
                        <div class="form-card">
                            <div class="form-card-header">
                                <h3>Amendment in progress</h3>
                            </div>
                            <div class="form-card-forms">
                                <div class="row">
                                    <div class="col-md-8">
                                        <label> Your Payment will be sent to:</label>
                                    </div>
                                    <div class="col-md-4">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>New Details</label>
                                    </div>
                                    <div class="col-md-4">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Name: </label>
                                    </div>
                                    <div class="col-md-4 text-bold">
                                        {{AmendDetail.NewDetail}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Previous Details</label>
                                    </div>
                                    <div class="col-md-4 text-bold">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Name: </label>
                                    </div>
                                    <div class="col-md-4 text-bold">
                                        {{AmendDetail.PreviousDetail}}
                                    </div>
                                </div>
                            </div>
                            <div style="text-align: center;padding-bottom: 8px">
                                <router-link :to="'/transaction'" class="btn submit-lefticon-btn">
                                    <span class="btn-content">OK</span>
                                </router-link>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import Base from "../../shared/Base.vue";
    import Action from "../../shared/Action.vue";
    import Mode from "../../shared/Mode.vue";
    import ListService from "../../services/list";
    export default {
        name: "Amend",
        extends: Base,
        props: ["txnrefno"],
        components: {
            Action,
            Mode
        },
        created() {
            this.url.amend = "v2/transaction/amend";
            this.index = 0;
        },
        data() {
            return {
                index: 0,
                vModel: {
                    Id: null,
                    FirstName: null,
                    LastName: null,
                    TransactionRefNo: null

                },
                TransactionDetail: {
                    SendAmount: "",
                    PayoutAmount: ""
                },

                AmendDetail: {
                    PreviousDetail: "",
                    NewDetail: ""
                }

            };
        },

        beforeRouteEnter(to, from, next) {
            var promises = [];
            if (to.params.txnrefno != undefined) {
                promises.push(ListService.getById("transaction/detail/" + to.params.txnrefno));

                Promise.all(promises).then(response => {
                    next(p => {
                        p.TransactionDetail = response[0].body;
                        p.vModel.Id = response[0].body.Beneficiary.Id;
                        p.vModel.FirstName = response[0].body.Beneficiary.FirstName;
                        p.vModel.LastName = response[0].body.Beneficiary.LastName;
                        p.vModel.TransactionRefNo = to.params.txnrefno;
                    });
                });
            }

        },

        methods: {

            onSubmit: function () {
                var self = this;
                if (self.isProcessing) return false;
                self.$validator.validateAll().then(result => {
                    if (result) {
                        self.isProcessing = true;
                        self.$http.post(self.url.amend, self.vModel).then(
                            response => {
                                self.AmendDetail = response.body;
                                self.index = 1;
                                self.isProcessing = false;
                            },
                            error => {
                                self.isProcessing = false;
                            }
                        );
                    }
                });
            },

            onCancel: function () {
                this.$router.push("/transaction")

            }

        }
    }
</script>